
const mutations = {
  SET_TEST1(state, value) {
    state.test1 = value
  },
  THEME_BAR(state, value) {
    state.themeBar = value
  },
  PROGRESSMSG(state, value) {
    state.progressmsg = value;
  },
  UPLOADING(state, value) {
    state.uploading = value
  },
  PERCENTAGE_UPLOADED(state, value) {
    state.percentageUploaded = value
  },
  RESET_SPLIT_BUTTON_LOCATION(state, value) {
    state.resetSplitButtonLocation = value
  },
  ERROR_MESSAGES(state, value) {
    state.errorsMessages = value
  },
  RELOGIN_DIALOG(state, value) {
    state.reLoginDialog = value
  },
  LAST_PAGE(state, value) {
    state.lastPage = value
  },
  LAST_FROM_PAGE(state, value) {
    state.lastFromPage = value
  },
  LAST_PATH_NAME(state, value) {
    state.lastPathName = value
  },
  LAST_EPs(state, value) {
    state.lastEPs = value
  },
  EP_ERROR(state, value) {
    state.epError = value
  },
  EP_PAYLOAD(state, value) {
    state.epPayload = value
  },
  ERROR_CODE(state, value) {
    state.errorCode = value
  },
  EP_DATETIME(state, value) {
    state.epDatetime = value
  },
  LAST_ERROR_EP(state, value) {
    state.lastErrorEP = value
  },
  STATIC_MENU_DESKTOP_INACTIVE(state, value) {
    state.staticMenuDesktopInactive = value
  },
  ACTIVE_THEME_COLOR(state, value) {
    state.activeThemeColor = value
  },
  APP_WINDOW_WIDTH(state, value) {
    state.appWindowWidth = value
  },
  APP_WINDOW_HEIGHT(state, value) {
    state.appWindowHeight = value
  },
  VIDEOS_DATA(state, value) {
    state.videosData = value
  },
  REQUESTING_VIDEOS(state, value) {
    state.requestingVideos = value
  }
}

export default mutations